export default {
  /**
   * Vai trò quyền hạn
   */
  RoleAction: {
    Add: 'Thêm',
    View: 'Sử dụng',
    Edit: 'Sửa',
    Delete: 'Xóa',
    Posted: 'Ghi sổ',
    UnPost: 'Bỏ ghi',
    Print: 'In',
    ReleaseEInvoice: 'Phát hành hóa đơn điện tử',
    SendInvoice: 'Gửi hóa đơn cho khách hàng',
    ConvertIntoPaperVoucher: 'Chuyển thành chứng từ giấy',
    DownloadInvoice: 'Tải hóa đơn',
    CancelInvoice: 'Hủy hóa đơn',
  },

  /**
   * Trạng thái của form
   */
  FormState: {
    Add: 'Thêm',
    View: 'Xem',
    Edit: 'Sửa',
    Duplicate: 'Thêm',
    QuickAdd: 'Thêm nhanh',
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: 'Nữ',
    Male: 'Nam',
    Other: 'Khác',
  },
  InDebt: {
    Debt: 'Dư nợ',
    ExcessYes: 'Dư có',
  },

  StatusReceipt: {
    All: 'Tất cả',
    ReceiptOrigin: 'Biên lai gốc',
    ReceiptDeleted: 'Biên lai xóa bỏ',
  },
  Operator: {
    And: 'Và',
    Or: 'Hoặc',
  },
  /**
   * toán tử filter
   */
  FilterOperator: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu với',
    EndsWith: 'Kết thúc với',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  FilterOperatorSearch: {
    Contains: 'Chứa',
    Notcontains: 'Không chứa',
    StartsWith: 'Bắt đầu bằng',
    EndsWith: 'Kết thúc bằng',
    Null: '(Trống)',
    NotNull: '(Không trống)',
    Equals: 'Bằng',
    NotEquals: 'Khác',
    GreaterThan: 'Lớn hơn',
    GreaterThanEquals: 'Lớn hơn hoặc bằng',
    LessThan: 'Nhỏ hơn',
    LessThanEquals: 'Nhỏ hơn hoặc bằng',
    Between: 'Trong khoảng',
  },

  Period: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    SixFirstMonth: 'Sáu tháng đầu năm',
    SixLastMonth: 'Sáu tháng cuối năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    Yesterday: 'Hôm qua',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    Tomorrow: 'Ngày mai',
    NextWeek: 'Tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },
  PeriodReport: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần tới hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng tới hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm tới hiện tại',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    NextWeek: 'Tuần sau',
    Next4Week: 'Bốn tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tự chọn',
  },

  // Chỉ lấy số của tháng
  PeriodMonth: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
  },

  Currency: {
    VND: 'VND',
    Dola: 'USD',
  },
  Pagination: {
    // Two: '2 bản ghi trên 1 trang',
    Ten: '10 bản ghi trên 1 trang',
    Twen: '20 bản ghi trên 1 trang',
    Thir: '30 bản ghi trên 1 trang',
    Fif: '50 bản ghi trên 1 trang',
    Hunder: '100 bản ghi trên 1 trang',
  },

  ReportPeriod: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: 'Sáu tháng đầu năm',
    SecondHalfYear: 'Sáu tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },
  ReportPeriodDcsdCustom: {
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    QuaterAll: 'Tất cả các quý',
    FirtsHalfYear: 'Sáu tháng đầu năm',
    SecondHalfYear: 'Sáu tháng cuối năm',
    Year: 'Cả năm',
    ThisMonth: 'Tháng này',
    ThisQuarter: 'Quý này',
    Custom: 'Tùy chọn',
  },

  ReportPeriodSettlement: {
    Year: 'Cả năm',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    QuarterI: 'Quý I',
    QuarterII: 'Quý II',
    QuarterIII: 'Quý III',
    QuarterIV: 'Quý IV',
    FirtsHalfYear: '6 tháng đầu năm',
    SecondHalfYear: '6 tháng cuối năm',
  },
  ReportPeriodCustom: {
    ThisDay: 'Hôm nay',
    ThisWeek: 'Tuần này',
    FirstWeekToPresent: 'Đầu tuần đến hiện tại',
    ThisMonth: 'Tháng này',
    FirstMonthToPresent: 'Đầu tháng đến hiện tại',
    ThisQuarter: 'Quý này',
    FirstQuarterToPresent: 'Đầu quý đến hiện tại',
    ThisYear: 'Năm nay',
    FirstYearToPresent: 'Đầu năm đến hiện tại',
    January: 'Tháng 1',
    February: 'Tháng 2',
    March: 'Tháng 3',
    April: 'Tháng 4',
    May: 'Tháng 5',
    June: 'Tháng 6',
    July: 'Tháng 7',
    August: 'Tháng 8',
    September: 'Tháng 9',
    October: 'Tháng 10',
    November: 'Tháng 11',
    December: 'Tháng 12',
    FiscalI: 'Quý I',
    FiscalII: 'Quý II',
    FiscalIII: 'Quý III',
    FiscalIV: 'Quý IV',
    LastWeek: 'Tuần trước',
    LastMonth: 'Tháng trước',
    LastQuarter: 'Quý trước',
    LastYear: 'Năm trước',
    NextWeek: 'Tuần sau',
    Next4Week: 'Bốn tuần sau',
    NextMonth: 'Tháng sau',
    NextQuarter: 'Quý sau',
    NextYear: 'Năm sau',
    Custom: 'Tùy chọn',
  },

  /**
   * Kí hiệu tiền tệ
   */
  MoneySign: {
    NormalVND: 'đ',
    UpperCaseVND: 'Đ',
    None: 'Không chọn',
  },
  /**
   * Ký tự ngăn cách
   */
  Separator: {
    Dot: '. (dấu chấm)',
    Comma: ', (dấu phẩy)',
  },
  /**
   * Định dạng số dương
   */
  PositiveFormat: {
    $n: '$n',
    '$ n': '$ n',
    n$: 'n$',
    'n $': 'n $',
  },
  /**
   * Định dạng số âm
   */
  NegativeFormat: {
    '($n)': '($n)',
    '-$n': '-$n',
    '$-n': '$-n',
    '$n-': '$n-',
    '(n$)': '(n$)',
    '-n $': '-n $',
    'n-$': 'n-$',
    'n $-': 'n $-',
    '-$ n': '-$ n',
    '$ n-': '$ n-',
    'n- $': 'n- $',
    '($ n)': '($ n)',
    '(n $)': '(n $)',
    '-n$': '-n$',
    'n$-': 'n$-',
  },

  /**
   * Kí hiệu âm
   */
  NegativeSign: {
    '(n)': '(n)',
    '-n': '-n',
    '- n': '- n',
    'n-': 'n-',
    'n -': 'n -',
  },
  /**
   * Font chữ
   */
  FontFamily: {
    TimesNewRoman: 'Times New Roman',
    OpenSan: 'Open San',
    Arial: 'Arial',
    Tahoma: 'Tahoma',
    Cambria: 'Cambria',
    ArialNarrow: 'Arial Narrow',
  },
  /**
   * Kiểu chữ
   */
  FontStyle: {
    Regular: 'Regular',
    Bold: 'Bold',
    Italic: 'Italic',
    BoldItalic: 'Bold Italic',
  },
  /**
   *Ghi chú - thiết lập quy tắc hạch toán đồng thời
   */
  SignType: {
    Record: 'Ghi âm',
    Positive: 'Ghi dương',
  },

  /**
   * Công thức âm dương
   */
  SignFormula: {
    Negative: '-',
    Positive: '+',
  },

  /**
   * Loại công thức
   */
  ColumnDataType: {
    // Hệ số
    Coefficient: 'Hệ số',
    // Tỷ lệ
    Rate: 'Tỷ lệ',
    // Khác
    Other: 'Khác',
  },

  MessageBoxType: {
    confirm_Info_Warning: 0,
    confirm_Yes_No: 1,
    confirm_Yes_No_Cancel: 2,
    confirm_Delete: 3,
    confirm_Close: 4,
  },

  /**
   * Enum Ngừng theo dõi
   */
  Inactive: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   * Enum Theo dõi
   */
  Active: {
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
  },

  /**
   *  Enum cấp
   */
  Kind: {
    Province: 'Tỉnh/Thành phố',
    District: 'Quận/Huyện',
    Ward: 'Xã/Phường',
  },

  /**
   * Đơn vị tính
   */
  UnitMoney: {
    One: 'Đồng',
    OneThousand: 'Nghìn đồng',
    OneMillion: 'Triệu đồng',
    OneBillion: 'Tỷ đồng',
  },

  FormulaSign: {
    add: '+',
    subtract: '-',
    multiple: 'x',
    divide: '/',
  },

  // loại icon hiển thị tại msCellInput
  SuffixIconType: {
    More: 0,
    View: 1,
    Edit: 2,
  },

  SearchField: {
    ref_date: 'ref_date',
    ref_no: 'ref_no',
    ref_type: 'ref_type',
    posted_date: 'posted_date',
    inv_date: 'inv_date',
    inv_no: 'inv_no',
    debit_account: 'debit_account',
    credit_account: 'credit_account',
    amount: 'amount',
    budget_source_code: 'budget_source_code',
    budget_chapter_code: 'budget_chapter_code',
    budget_provide_code: 'budget_provide_code',
    budget_kind_item_code: 'budget_kind_item_code',
    budget_sub_kind_item_code: 'budget_sub_kind_item_code',
    method_distribute_type: 'method_distribute_type',
    budget_item_code: 'budget_item_code',
    budget_sub_item_code: 'budget_sub_item_code',
    accounting_object_code: 'accounting_object_code',
    inventory_item_code: 'inventory_item_code',
    inventory_item_tool_code: 'inventory_item_tool_code',
    quantity: 'quantity',
    stock_code: 'stock_code',
    description: 'description',
    activity_code: 'activity_code',
    cash_withdraw_type_id: 'cash_withdraw_type_id',
    fixed_asset_code: 'fixed_asset_code',
    project_code: 'project_code',
    fund_code: 'fund_code',
    department_code: 'department_code',
    statistic_code: 'statistic_code',
    is_treasury_approved: 'is_treasury_approved',
    approved_date: 'approved_date',
    debit_bank_account: 'debit_bank_account',
    credit_bank_account: 'credit_bank_account',
    bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
    budget_source_property_code: 'budget_source_property_code',
    budget_fees_code: 'budget_fees_code',
    contract_no: 'contract_no',
    contract_sell_no: 'contract_sell_no',
  },

  /**
   * Kích thước trang báo cáo
   */
  PageSize: {
    A4: 'A4',
    A3: 'A3',
  },

  /**
   * Kỳ tính khấu hao
   */
  DevaluationPeriod: {
    Month: 'Tháng',
    Quarter: 'Quý',
  },

  /**
   * Nhật ký truy cập
   */
  Action: {
    Insert: 'Thêm',
    Update: 'Sửa',
    Delete: 'Xóa',
  },

  /**
   * Quyền sau cần thì bổ sung thêm sau
   */
  Permission: {
    Add: 'Thêm',
    Edit: 'Sửa',
    Delete: 'Xóa',
    BackupData: 'Sao lưu dữ liệu',
    RestoreData: 'Phục hồi dữ liệu',
    CreateData: 'Thêm mới dữ liệu',
    CreateDataPrevYear: 'Thêm mới từ dữ liệu năm trước',
    DeleteData: 'Xóa dữ liệu',
    RenameData: 'Đổi tên dữ liệu',
    RestoreVoucher: 'Phục hồi',
    RebuildData: 'Bảo trì',
  },

  /**
   * Enum trạng thái
   * Dùng trong bộ lọc
   */
  ActiveFilter: {
    Active: 'Theo dõi',
    Inactive: 'Ngừng theo dõi',
  },

  UpDownEnum: {
    Asc: 'Tăng dần',
    Desc: 'Giảm dần',
  },

  Action: {
    Insert: 'insert',
    Update: 'update',
  },
  ApplicationType: {
    BuiltIn: 'Ứng dụng tích hợp sẵn',
    Porting: 'Ứng dụng bên ngoài',
    IntegratedApp: 'Ứng dụng tích hợp',
  },
  GettingStartedStatus: {
    Completed: 'Đã hoàn thành',
    NotCompleted: 'Chưa hoàn thành',
  },
};
